import { render, staticRenderFns } from "./BannerItem.vue?vue&type=template&id=472a1a90&"
import script from "./BannerItem.vue?vue&type=script&lang=js&"
export * from "./BannerItem.vue?vue&type=script&lang=js&"
import style0 from "./BannerItem.vue?vue&type=style&index=0&id=472a1a90&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports